import { render, staticRenderFns } from "./Pl3.vue?vue&type=template&id=33dde800&scoped=true"
import script from "./Pl3.vue?vue&type=script&lang=js"
export * from "./Pl3.vue?vue&type=script&lang=js"
import style0 from "./Pl3.vue?vue&type=style&index=0&id=33dde800&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dde800",
  null
  
)

export default component.exports